import { useRequest } from "../contexts/request";
import { useQuery } from "react-query";

const useWishlistDonatorPublic = (slug, page = 1, limit = 10) => {
  const { get } = useRequest();

  return useQuery(
    ["wishlist-public-donator", slug, page, limit],
    async () => {
      if (slug) {
        const {
          json: { data },
        } = await get(
          `wishlist/donator/public/${slug}?page=${page}&limit=${limit}`
        );
        return data;
      }
    },
    {
      enabled: !!slug,
      keepPreviousData: true,
      staleTime: 0,
    }
  );
};

export { useWishlistDonatorPublic };
